import { observer } from 'mobx-react-lite';
import InterviewResults from 'components/InterviewResults';
import { vacancyStore } from 'stores/vacancyStore';
import Page404 from './Page404';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

const CandidateResultPage = () => {
  const { candidateInterview, candidateReport } = vacancyStore;
  const { vacancyId, userId } = useParams<{ vacancyId: string; userId: string }>();

  useEffect(() => {
    const load = async () => {
      if(!candidateInterview) {
        try {
          await vacancyStore.getInterviewsByVacancyId(vacancyId as string)
          const interview = vacancyStore.interviews.find(i => i.userId === userId)
          if(interview) {
            vacancyStore.candidateReport = interview.report || null;
            vacancyStore.candidateInterview = interview || null;
          }
        } catch (error) {
          console.error(error);
        }
      }
    }
    load();
  }, [candidateInterview, vacancyId, userId])

  return (
    <InterviewResults isCandidate interview={candidateInterview}/>
  );
};

export default observer(CandidateResultPage);
